/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */

import React from 'react';
import { Fade } from 'react-awesome-reveal';

export default function AboutUs() {
  return (
    <section className="w-full min-h-screen flex items-start justify-center bg-white px-4 sm:px-6 lg:px-12 pt-6 sm:pt-8 pb-10 sm:pb-12">
  <div className="w-full max-w-6xl text-gray-700 space-y-6">
    <Fade direction="up" triggerOnce>
      <h1 className="text-4xl sm:text-5xl font-bold text-theme-blue mb-6 sm:mb-10">
        About Us
      </h1>
    </Fade>

    <Fade direction="up" delay={200} triggerOnce>
      <p className="font-light text-xl sm:text-lg leading-relaxed">
        <strong>MS Contractors Pty Ltd</strong> is a well-established civil services company with a strong reputation for delivering reliable, high-quality solutions in the telecommunications and cabling industry. Based in Wollert, we proudly service all around Victoria.
      </p>
    </Fade>

    <Fade direction="up" delay={300} triggerOnce>
      <p className="font-light text-xl sm:text-lg leading-relaxed">
        Our core expertise lies in <strong>network cable installation</strong>, <strong>telecommunication infrastructure</strong>, and <strong>structured cabling solutions</strong> for residential, commercial, and industrial projects.
      </p>
    </Fade>

    <Fade direction="up" delay={400} triggerOnce>
      <p className="font-light text-xl sm:text-lg leading-relaxed">
        In addition to telecommunications, we’re licensed and insured for <strong>asbestos removal</strong>. This includes asbestos cement pits, piping, and other infrastructure commonly found in telecom networks.
      </p>
    </Fade>

    <Fade direction="up" delay={500} triggerOnce>
      <p className="font-light text-xl sm:text-lg leading-relaxed">
        Our in-house team is made up of highly trained professionals employed full-time, ensuring consistent quality and safety across all projects.
      </p>
    </Fade>

    <Fade direction="up" delay={600} triggerOnce>
      <p className="font-light text-xl sm:text-lg leading-relaxed">
        Contact us at{' '}
        <a
          href="mailto:info@mscontractors.com.au"
          className="text-blue-600 font-semibold underline hover:text-blue-800 transition-all duration-300"
        >
          info@mscontractors.com.au
        </a>{' '}
        — we’d love to help with your next project.
      </p>
    </Fade>
  </div>
</section>

  );
}
